import { i18n } from '../i18n';

export const getErrorCode = err => {
  const response = err?.response;
  if (!response) return 'network';
  return response.data?.error || (response.status === 429 ? 'too_many_requests' : null);
};

export const getErrorMessage = err => {
  const code = getErrorCode(err);
  if (code) {
    const key = `errors.${code}`;
    const text = i18n.t(key);
    if (text !== key) return text;
  }
  return err?.response?.data?.message || i18n.t('errors.unknown');
};
